import { render, staticRenderFns } from "./DispensaLances.vue?vue&type=template&id=078b21e9&scoped=true&"
import script from "./DispensaLances.vue?vue&type=script&lang=js&"
export * from "./DispensaLances.vue?vue&type=script&lang=js&"
import style0 from "./DispensaLances.vue?vue&type=style&index=0&id=078b21e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b21e9",
  null
  
)

export default component.exports